const isBrowser = typeof window !== 'undefined';

/**
 *
 * @type {Readonly<{Unknown: string, Safari: string, Chrome: string, Edge: string, Opera: string, Firefox: string}>}
 */
export const BrowserName = Object.freeze({
  Chrome: 'chrome',
  Firefox: 'firefox',
  Safari: 'safari',
  Opera: 'opera',
  Edge: 'edge',
  Unknown: 'unknown'
})

/**
 *
 * @type {Readonly<{Window: string, Unknown: string, IOS: string, Android: string}>}
 */
export const MobileSystemName = Object.freeze({
  Window: 'window',
  Android: 'android',
  IOS: 'iOS',
  Unknown: 'unknown'
})

/**
 * /
 *  Determine the browser.
 *  This function returns one of 'chrome', 'firefox', 'safari', 'opera', 'edge', or 'unknown'.
 * @returns {string}
 */
export const getBrowser = () => {
  if (isBrowser) {
    const userAgent = navigator.userAgent;
    if (userAgent.match(/chrome|chromium|crios/i)) {
      return BrowserName.Chrome;
    } else if (userAgent.match(/firefox|fxios/i)) {
      return BrowserName.Firefox;
    } else if (userAgent.match(/safari/i)) {
      return BrowserName.Safari;
    } else if (userAgent.match(/opr\//i)) {
      return BrowserName.Opera;
    } else if (userAgent.match(/edg/i)) {
      return BrowserName.Edge;
    }
  }
  return BrowserName.Unknown
}


/**
 * Determine the mobile  system.
 * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
 *
 * @returns {String}
 */
export const getMobileSystem = () => {
  if (isBrowser) {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return MobileSystemName.Window;
    }
    if (/android/i.test(userAgent)) {
      return MobileSystemName.Android;
    }
    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return MobileSystemName.IOS;
    }
    return MobileSystemName.Unknown;
  }
  return MobileSystemName.Unknown;
}

